<li class="nav-item position-relative zi-3" style="list-style: none">

  <!-- Trigger button -->
  <button class="cart-btn" (click)="showDropdown()" title="Cart">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="8" cy="21" r="1" />
      <circle cx="19" cy="21" r="1" />
      <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
    </svg>
    <span class="headerCartCount" *ngIf="ss.cartItems.length > 0">{{ ss.cartItems.length }}</span>
  </button>

  <!-- Dropdown panel -->
  <div class="cart-dropdown" *ngIf="isCartDropdownOpen">

    <!-- Header -->
    <div class="cart-dropdown-hdr">
      <div class="cart-dropdown-title">
        <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <circle cx="8" cy="21" r="1" /><circle cx="19" cy="21" r="1" />
          <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
        </svg>
        Cart
        <span class="cart-count-pill">{{ ss.cartItems.length }}</span>
      </div>
      <button class="cart-close-btn" (click)="showDropdown()" title="Close">
        <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Empty state -->
    <div class="cart-empty" *ngIf="ss.cartItems.length == 0">
      <svg width="36" height="36" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" style="opacity:0.3">
        <circle cx="8" cy="21" r="1" /><circle cx="19" cy="21" r="1" />
        <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
      </svg>
      <span>Your cart is empty</span>
    </div>

    <!-- Items list -->
    <div class="cart-items-list">
      <div class="cart-item" *ngFor="let item of ss.cartItems">
        <div class="cart-item-icon">
          <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <rect x="3" y="3" width="18" height="18" rx="4" />
            <path stroke-linecap="round" d="M9 12h6M12 9v6" />
          </svg>
        </div>
        <div class="cart-item-info">
          <span class="cart-item-category">Categories / Widget</span>
          <span class="cart-item-name">Minimum Wage Per State</span>
        </div>
        <div class="cart-item-price">
          <span class="cart-price-sign">$</span>400
        </div>
        <button class="cart-remove-btn" (click)="ss.removeFromCart()" title="Remove">
          <svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
            <path stroke-linecap="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Footer total -->
    <div class="cart-dropdown-footer" *ngIf="ss.cartItems.length > 0">
      <span class="cart-total-label">Total</span>
      <span class="cart-total-value">$400</span>
      <button class="cart-checkout-btn">
        Checkout
        <svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
        </svg>
      </button>
    </div>

  </div>
</li>
